<template>
    <el-menu unique-opened :default-active="$route.path">
        <sidebar-item :routes='permission_routers'></sidebar-item>
    </el-menu>
</template>


<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
export default {
    components: { SidebarItem },
    data() {
        return {
            collapse: true,
        };
    },
    computed: {
        ...mapGetters(["permission_routers", "sidebar"]),
        isCollapse() {
            return !this.sidebar.opened;
        }
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>


// WEBPACK FOOTER //
// Sidebar.vue?bbc435f4